export default __webpack_public_path__ + "static/media/logout-20.8ee32f17.svg";